var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-zoom"},[_c('button',{staticClass:"zoom-in",on:{"click":_vm.zoomIn}}),_c('button',{staticClass:"zoom-out",on:{"click":_vm.zoomOut}})])}
var staticRenderFns = []

export { render, staticRenderFns }